import React from 'react';
import { useParams } from 'react-router-dom';
import UsageDetailView, { Field, UsageDetailPage, UsageEntriesQuery } from '../components/converter/UsageDetailView';
import { Badge } from '../components/StatusBadge';
import { apiService } from '../services/api';
import { ApiUsageRequest } from '../types';
import { formatDateTimeUTC, formatDuration } from '../utils/dateTime';
import { apiKeyName, maskApiKey } from '../utils/apiKey';

async function loadRequest(id: string, query: UsageEntriesQuery): Promise<UsageDetailPage<ApiUsageRequest>> {
    const res = await apiService.converterGetUsageRequest(id, query);
    return { subject: res.data.request, entries: res.data.usage || [], total: res.data.total || 0 };
}

function ApiRequestDetail() {
    const { id } = useParams<{ id: string }>();

    return (
        <UsageDetailView<ApiUsageRequest>
            id={id}
            backTo="/usage?tab=api"
            pageSizeKey="api-request-files"
            load={loadRequest}
            noun="request"
            title={(request) => apiKeyName(request)}
            titleAside={(request) => <Badge value={request.status} />}
            notice={(request) => request.error_message}
            // An error request has no entries.
            showUsage={(request) => request.status === 'success'}
            fields={(request) => (
                <>
                    <Field label="Operation">{request.operation}</Field>
                    <Field label="API Key">
                        {request.api_key_name}
                        <span className="text-secondary font-mono ml-2">{maskApiKey(request)}</span>
                    </Field>
                    <Field label="Started At">{formatDateTimeUTC(request.started_at)}</Field>
                    <Field label="Completed At">{formatDateTimeUTC(request.completed_at)}</Field>
                    <Field label="Duration">{formatDuration(request.started_at, request.completed_at)}</Field>
                </>
            )}
        />
    );
}

export default ApiRequestDetail;
